import React from 'react';
import './assets/css/content.css'

class Content extends React.Component{
    render(){
        return(
        <div className="content" id="content">
            <img src="https://cdn.glitch.com/2253e7eb-7cc6-4544-bb4f-c0e224affccb%2Fthumbnails%2Fsadsadsadsadsadsadsadsaddsasadsaddsasadsadasdassadsaasdassd.png" width="40%" height="auto" id="content-logo"></img>
            <div className="content-bot-info">
                <div className="row">
                    <div className="col-lg-4" id="content-bot-info-author">
                    <h1 id="content-titles-info">Developed by</h1>
                    <a href="https://www.twitter/vjeanr" id="author-bot">Jean</a>
                    </div>

                    <div className="col-lg-4" id="content-bot-info-author">
                    <h1 id="content-titles-info">Stadistics</h1>
                    <a id="things-bot">105 Commands</a>
                    </div>

                    <div className="col-lg-4" id="content-bot-info-library">
                    <h1 id="content-titles-info">Created Date</h1>
                    <a id="things-bot">20/24/2019</a>
                    </div>
                </div>
            </div>
        </div>
        )
    };
}

export default Content;